<ng-container *ngIf="errors[name]">
  <span *ngFor="let error of errors[name]" dir="rtl" class="text-danger mt-2 d-block text-right"
        [style]="customStyle.join(';')">
          {{error |  formatNumber:'toPersian'}}
  </span>
</ng-container>
